module.exports = __webpack_public_path__ + "static/img/logo.56ac1f28.png";